import { ChainId, JSBI, Token, WETH } from '../sdk'

export const BIPS_BASE = JSBI.BigInt(10000)
export const AddressZero = '0x0000000000000000000000000000000000000000'

// Reference: https://docs.pyth.network/price-feeds/contract-addresses/evm
export const PYTH_ADDRESS: any = {
  // For V2
  [ChainId.SEPOLIA]: '0xDd24F84d36BF92C65F92307595335bdFab5Bbd21',
  [ChainId.ARBITRUM_SEPOLIA]: '0x4374e5a8b9C22271E9EB878A2AA31DE97DF15DAF',
  [ChainId.ARBITRUM_MAINNET]: '0xff1a0f4744e8582DF1aE09D5611b887B6a12925C',
  [ChainId.BSC_MAINNET]: '0x4D7E825f80bDf85e913E0DD2A2D54927e9dE1594',
  [ChainId.BASE_MAINNET]: '0x8250f4aF4B972684F7b336503E2D6dFeDeB1487a',
  [ChainId.BERA_MAINNET]: '0x2880aB155794e7179c9eE2e38200202908C17B43',
  [ChainId.HYPER_EVM]: '0xe9d69CdD6Fe41e7B621B4A688C5D1a68cB5c8ADc',
  [ChainId.LINEA_MAINNET]: '0xA2aa501b19aff244D90cc15a4Cf739D2725B5729',
  // For V1
  [ChainId.VICTION_MAINNET]: '0xA2aa501b19aff244D90cc15a4Cf739D2725B5729',
  [ChainId.SONIC_TESTNET]: '0x96124d1f6e44ffdf1fb5d6d74bb2de1b7fbe7376',
  [ChainId.AURORA_TESTNET]: '0x74f09cb3c7e2A01865f424FD14F6dc9A14E3e94E',
  [ChainId.TAIKO_TESTNET]: '0x2880aB155794e7179c9eE2e38200202908C17B43',
  [ChainId.BOBA_TESTNET]: '0x8D254a21b3C86D32F7179855531CE99164721933',
  [ChainId.BOBA_MAINNET]: '0x4374e5a8b9C22271E9EB878A2AA31DE97DF15DAF'
}

export const RPC_URLS: any = {
  [ChainId.SEPOLIA]: 'https://sepolia.drpc.org',
  [ChainId.BSC_TESTNET]: 'https://bsc-testnet.drpc.org',
  [ChainId.BSC_MAINNET]: 'https://bsc.drpc.org',
  [ChainId.VICTION_TESTNET]: 'https://rpc-testnet.viction.xyz',
  [ChainId.VICTION_MAINNET]: 'https://rpc.viction.xyz',
  [ChainId.BASE_SEPOLIA]: 'https://base-sepolia-rpc.publicnode.com',
  [ChainId.BASE_MAINNET]: 'https://base.llamarpc.com',
  [ChainId.BOBA_TESTNET]: 'https://sepolia.boba.network',
  [ChainId.U2U_MAINNET]: 'https://rpc-mainnet.u2u.xyz',
  [ChainId.ARBITRUM_SEPOLIA]: 'https://sepolia-rollup.arbitrum.io/rpc',
  [ChainId.ARBITRUM_MAINNET]: 'https://arb1.arbitrum.io/rpc',
  [ChainId.BERA_MAINNET]: 'https://rpc.berachain.com',
  [ChainId.HYPER_EVM]: 'https://hyperliquid.drpc.org',
  [ChainId.LINEA_MAINNET]: 'https://linea.drpc.org',
  [ChainId.OP_MAINNET]: 'https://optimism.llamarpc.com',
  [ChainId.BOBA_MAINNET]: 'https://mainnet.boba.network'
}

export enum Field {
  CURRENCY_A = 'CURRENCY_A',
  CURRENCY_B = 'CURRENCY_B',
  LIQUIDITY_PERCENT = 'LIQUIDITY_PERCENT',
  LIQUIDITY = 'LIQUIDITY'
}

export enum ApprovalState {
  UNKNOWN,
  NOT_APPROVED,
  PENDING,
  APPROVED
}

export const DAI = new Token(
  ChainId.MAINNET,
  '0x6B175474E89094C44Da98b954EedeAC495271d0F',
  18,
  'DAI',
  'Dai Stablecoin'
)
export const USDC = new Token(
  ChainId.MAINNET,
  '0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48',
  6,
  'USDC',
  'USD//C'
)
export const USDT = new Token(
  ChainId.MAINNET,
  '0xdAC17F958D2ee523a2206206994597C13D831ec7',
  6,
  'USDT',
  'Tether USD'
)
export const WBTC = new Token(
  ChainId.MAINNET,
  '0x2260FAC5E5542a773Aa44fBCfeDf7C193bc2C599',
  8,
  'WBTC',
  'Wrapped BTC'
)

export const UNICHAIN_USDC = new Token(
  ChainId.UNICHAIN_SEPOLIA,
  '0x8Aca9B80b6752Ec62e06eC48E07a301e97852dAA',
  18,
  'USDC',
  'USDC'
)

export const METIS_USDC = new Token(
  ChainId.METIS_MAINNET,
  '0xEA32A96608495e54156Ae48931A7c20f0dcc1a21',
  6,
  'USDC',
  'USDC'
)

export const PINNED_PAIRS: {
  readonly [chainId in ChainId]?: [Token, Token][]
} = {
  [ChainId.MAINNET]: [
    [
      new Token(
        ChainId.MAINNET,
        '0x5d3a536E4D6DbD6114cc1Ead35777bAB948E3643',
        8,
        'cDAI',
        'Compound Dai'
      ),
      new Token(
        ChainId.MAINNET,
        '0x39AA39c021dfbaE8faC545936693aC917d5E7563',
        8,
        'cUSDC',
        'Compound USD Coin'
      )
    ],
    [USDC, USDT],
    [DAI, USDT]
  ]
}

type ChainTokenList = {
  readonly [chainId in ChainId]: Token[]
}

export const WETH_ONLY: ChainTokenList = {
  [ChainId.MAINNET]: [WETH[ChainId.MAINNET]],
  [ChainId.SEPOLIA]: [WETH[ChainId.SEPOLIA]],
  [ChainId.SN_MAIN]: [WETH[ChainId.SN_MAIN]],
  [ChainId.SN_SEPOLIA]: [WETH[ChainId.SN_SEPOLIA]],
  [ChainId.BSC_TESTNET]: [WETH[ChainId.BSC_TESTNET]],
  [ChainId.BSC_MAINNET]: [WETH[ChainId.BSC_MAINNET]],
  [ChainId.VICTION_TESTNET]: [WETH[ChainId.VICTION_TESTNET]],
  [ChainId.VICTION_MAINNET]: [WETH[ChainId.VICTION_MAINNET]],
  [ChainId.SONIC_TESTNET]: [WETH[ChainId.SONIC_TESTNET]],
  [ChainId.MINATO_SONEIUM]: [WETH[ChainId.MINATO_SONEIUM]],
  [ChainId.BASE_SEPOLIA]: [WETH[ChainId.BASE_SEPOLIA]],
  [ChainId.BASE_MAINNET]: [WETH[ChainId.BASE_MAINNET]],
  [ChainId.UNICHAIN_SEPOLIA]: [WETH[ChainId.UNICHAIN_SEPOLIA]],
  [ChainId.AURORA_TESTNET]: [WETH[ChainId.AURORA_TESTNET]],
  [ChainId.METIS_MAINNET]: [WETH[ChainId.METIS_MAINNET]],
  [ChainId.TAIKO_TESTNET]: [WETH[ChainId.TAIKO_TESTNET]],
  [ChainId.BOBA_TESTNET]: [WETH[ChainId.BOBA_TESTNET]],
  [ChainId.NEOX_MAINNET]: [WETH[ChainId.NEOX_MAINNET]],
  [ChainId.U2U_MAINNET]: [WETH[ChainId.U2U_MAINNET]],
  [ChainId.SCROLL_TESTNET]: [WETH[ChainId.SCROLL_TESTNET]],
  [ChainId.ARBITRUM_SEPOLIA]: [WETH[ChainId.ARBITRUM_SEPOLIA]],
  [ChainId.ARBITRUM_MAINNET]: [WETH[ChainId.ARBITRUM_MAINNET]],
  [ChainId.BERA_MAINNET]: [WETH[ChainId.BERA_MAINNET]],
  [ChainId.HYPER_EVM]: [WETH[ChainId.HYPER_EVM]],
  [ChainId.LINEA_MAINNET]: [WETH[ChainId.LINEA_MAINNET]],
  [ChainId.OP_MAINNET]: [WETH[ChainId.OP_MAINNET]],
  [ChainId.BOBA_MAINNET]: [WETH[ChainId.BOBA_MAINNET]]
}

export const BASES_TO_TRACK_LIQUIDITY_FOR: ChainTokenList = {
  ...WETH_ONLY,
  [ChainId.MAINNET]: [...WETH_ONLY[ChainId.MAINNET], DAI, USDC, USDT, WBTC]
}

export interface SerializedToken {
  chainId: number
  address: string
  decimals: number
  symbol?: string
  name?: string
}

export interface SerializedPair {
  token0: SerializedToken
  token1: SerializedToken
}
